import { Component, Input, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { CatGoalRegionModel } from 'src/app/model/cat-goal-region.model';
import { CatGoalRegionService } from 'src/oldApp/services/cat-goal-region.service';

@Component({
  selector: 'app-modal-goal-region',
  templateUrl: './modal-goal-region.component.html',
  styleUrls: ['./modal-goal-region.component.css']
})
export class ModalGoalRegionComponent implements OnInit {
  @Input() region:CatGoalRegionModel;
  @Input() page:string;
  @Input() mode:string;

  // estado pagina
  public viewStatus:number=1;

  // marcaras
  public customPatterns={
    'A':{pattern:new RegExp('[a-zA-Z0-9ñÑ ]')},                     // inputs regulares
    'C':{pattern:new RegExp('[a-zA-Z0-9áéíóúÁÉÍÓÚüÜñÑ,._:%\/() \-]')},       // comentarios (acepta acentos, comas y puntos)
    'N':{pattern:new RegExp('[0-9]')}
  };

  ////////////////
  constructor(
    private goalRegionService:CatGoalRegionService,
    private modalService: NgbModal,
    private toastr:ToastrService
  ) { }
  ngOnInit() { }

  //
  updateCommission=e=> this.region.commission=!e || e.trim()===''?null:Number(e);
  updateCommissionFisofo=e=> this.region.commissionFisofo=!e || e.trim()===''?null:Number(e);
  toggleActive=()=> this.region.activeId=!this.region.activeId;
  toggleActiveFisofo=()=> this.region.activeIdFisofo=!this.region.activeIdFisofo;
  isValid=()=> {
    let valid=true;
    let errors=[];
    if(this.descriptionError()) errors.push('Necesita capturar una descripción.');
    if(this.commissionError()) errors.push('Necesita capturar una comisión.');
    if(this.commissionErrorFisofo()) errors.push('Necesita capturar una comisión de Fisofo.');
    if(errors.length>0) {
      valid=false;
      this.toastr.error(errors.join('<br>'), '¡Atención!', {enableHtml:true});
    }
    return valid;
  }
  save=()=> {
    if(this.isValid()) {
      // mostrar spinner
      this.viewStatus=0;
      // enviar informacion
      this.region.regionDescription=this.region.regionDescription.toUpperCase();
      this.goalRegionService.save(this.region)
        .pipe(
          tap((resp:any)=> {
            console.log(resp);
            this.modalService.dismissAll('success');
            this.toastr.success('La categoría se guardó con éxito.');
          }),
          catchError(error=> {
            console.log(error);
            this.modalService.dismissAll('failure');
            return of(this.toastr.error('Ocurrió un error al intentar guardar la categoría.'));
          })
        )
        .subscribe();
    }
  }
  close=()=> this.modalService.dismissAll();

  // HELPERS
  descriptionError=()=> !this.region.regionDescription || this.region.regionDescription.trim()==='';
  commissionError=()=> !this.region.commission;
  commissionErrorFisofo=()=> !this.region.commissionFisofo;

}
